/**
 * Utilities for date formatting in offers
 */

/**
 * Get formatted validity date (today + 14 days)
 * @param {string} language - Current language code (en, ua, ru, pl)
 * @returns {string} Formatted date string
 */
export const getValidityDate = (language = 'en') => {
  // Calculate today + 14 days
  const validityDate = new Date();
  validityDate.setDate(validityDate.getDate() + 14);
  
  const monthNames = {
    en: ['January', 'February', 'March', 'April', 'May', 'June', 
          'July', 'August', 'September', 'October', 'November', 'December'],
    ua: ['січня', 'лютого', 'березня', 'квітня', 'травня', 'червня',
          'липня', 'серпня', 'вересня', 'жовтня', 'листопада', 'грудня'],
    ru: ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня',
          'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'],
    pl: ['stycznia', 'lutego', 'marca', 'kwietnia', 'maja', 'czerwca',
          'lipca', 'sierpnia', 'września', 'października', 'listopada', 'grudnia']
  };
  
  const day = validityDate.getDate();
  const month = monthNames[language] || monthNames['en'];
  const year = validityDate.getFullYear();
  
  return `${day} ${month[validityDate.getMonth()]} ${year}`;
};

/**
 * Get validity date in short format (dd.mm.yy)
 * @returns {string} Short date format
 */
export const getValidityDateShort = () => {
  const validityDate = new Date();
  validityDate.setDate(validityDate.getDate() + 14);
  
  const day = String(validityDate.getDate()).padStart(2, '0');
  const month = String(validityDate.getMonth() + 1).padStart(2, '0');
  const year = String(validityDate.getFullYear()).slice(-2);
  
  return `${day}.${month}.${year}`;
};

/**
 * Get offer generation date (current date)
 * @returns {string} ISO date string
 */
export const getOfferGenerationDate = () => {
  return new Date().toISOString().split('T')[0]; // YYYY-MM-DD format
};

/**
 * Get validity date based on offer creation date (created_at + 14 days)
 * @param {string} createdAt - ISO date string of offer creation
 * @returns {string} Short date format (dd.mm.yy)
 */
export const getOfferValidityDate = (createdAt) => {
  if (createdAt) {
    const date = new Date(createdAt);
    date.setDate(date.getDate() + 14);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = String(date.getFullYear()).slice(-2);
    return `${day}.${month}.${year}`;
  }
  return getValidityDateShort(); // fallback for new offers without created_at
};